import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/createClass";
import { getAllCookies } from "crusher-app/src/utils/common/cookieUtils";
export var waitForSegmentToLoad = function waitForSegmentToLoad() {
  return new Promise(function (res) {
    var timer = setInterval(function () {
      if (!!window["analytics"]) {
        res();
        clearInterval(timer);
      }
    }, 100);
  });
};
export var Analytics = /*#__PURE__*/function () {
  function Analytics() {
    _classCallCheck(this, Analytics);
  }

  _createClass(Analytics, null, [{
    key: "identify",
    value: function () {
      var _identify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, userId, email, teamID, planType, selfHost, mode) {
        var isBotUser, emailToTrack, userIdToTrack, CRUSHER_USER_ID;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isBotUser = email.includes("testing-") && email.includes("crusher.dev");
                emailToTrack = isBotUser ? "bot@crusher.dev" : email;
                userIdToTrack = isBotUser ? "9999999999999" : userId;
                _context.next = 5;
                return waitForSegmentToLoad();

              case 5:
                window["analytics"].identify(userIdToTrack, {
                  name: name,
                  teamID: teamID,
                  email: emailToTrack,
                  planType: planType,
                  selfHost: selfHost,
                  mode: mode
                });
                CRUSHER_USER_ID = getAllCookies()["CRUSHER_USER_ID"];

                if (!!CRUSHER_USER_ID) {
                  window["analytics"].identify(CRUSHER_USER_ID, {
                    email: email
                  });
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function identify(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _identify.apply(this, arguments);
      }

      return identify;
    }()
  }, {
    key: "trackPage",
    value: function () {
      var _trackPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return waitForSegmentToLoad();

              case 2:
                window["analytics"].page();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function trackPage() {
        return _trackPage.apply(this, arguments);
      }

      return trackPage;
    }()
  }]);

  return Analytics;
}();